import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

const selectServicing = createSelector(selectLoanApplication, ({ servicing }) => servicing);

export const selectServicingPayments = createSelector(
  selectServicing,
  servicing => servicing?.payments ?? [],
);

export const selectServicingPaymentSchedule = createSelector(
  selectServicing,
  servicing => servicing?.paymentSchedule ?? [],
);

export const selectServicingSummary = createSelector(
  selectServicing,
  servicing => servicing?.summary,
);

export const selectServicingEscrowDisbursements = createSelector(
  selectServicing,
  servicing => servicing?.escrowDisbursements ?? [],
);

export const selectServicingInteractions = createSelector(
  selectServicing,
  servicing => servicing?.interactions ?? [],
);

export const selectServicingDrawRequests = createSelector(
  selectServicing,
  servicing => servicing?.drawRequests ?? [],
);
